import React from 'react';

import helpers from '../lib/helpers';

export default class ContentItemHtml extends React.Component {

  componentDidMount() {
    //bind app links in html content
    let container = this.refs.container,
        _this = this;
    console.log('container', container);
    container.querySelectorAll('a[data-dynamic-link="true"]').forEach(link=>{
      link.addEventListener('click', function(e) {
        e.preventDefault();
        _this.props.goToUrl(link.getAttribute('href'));
      });
    });
  }

  render() {
    const replaceInternalLinks = function(content) {
      //turns content string (<p>This is a <a href="#1234">link to another page)
      //into content with good links (<p>This is a <a href="?page=1234&title=ive-received-payments-for-weekly-payments">link to another page)
      let matches = content.match(/href="#\d+"/g);
      if(matches) {
        let strLinksReplaced = content;
        matches.forEach(str=>{
          let pageId = str.replace(/href=|"|#/g,''),
              page = matrixData.pages[pageId];
          if(page) {
            let newUrl = helpers.getUrlTitle(pageId);
            strLinksReplaced = strLinksReplaced.replace(
              'href="#'+pageId, 
              'data-dynamic-link="true" href="'+ newUrl
            );
          }
        });
        return strLinksReplaced;
      }

      return content;
    };

    const createMarkup = function(content) { 
      return {__html: replaceInternalLinks(content)}; 
    };

    return (<div ref="container">
      <div dangerouslySetInnerHTML={createMarkup(this.props.content)} />
    </div>)
  }
}          
